export default __webpack_public_path__ + "static/media/settings-dark.44404a13.svg";